import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { TsRadioGroupComponent } from './ts-radio-group.component';

@Component({
  selector: 'ts-radio-button',
  standalone: true,
  imports: [MatRadioModule],
  template: `
    <mat-radio-button
      [value]="value"
      [checked]="checked"
      [disabled]="disabled"
      [disableRipple]="disableRipple"
      [tabIndex]="tabIndex"
      (change)="onChange($event)"
    >
      <ng-content />
    </mat-radio-button>
  `,
  host: { class: 'ts-radio-button' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TsRadioButtonComponent implements OnInit, OnDestroy {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly group = inject(TsRadioGroupComponent, { optional: true });

  @Input({ required: true }) value: unknown;
  @Input() disabled = false;
  @Input() disableRipple = false;
  @Input() tabIndex = 0;

  get checked(): boolean {
    return this.group?.value === this.value;
  }

  ngOnInit(): void {
    this.group?.registerButton(this);
  }

  ngOnDestroy(): void {
    this.group?.unregisterButton(this);
  }

  markForCheck(): void {
    this.cdr.markForCheck();
  }

  onChange(event: MatRadioChange): void {
    this.group?.onValueChange(event.value, this);
  }
}
